<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row>
          <b-col cols="12" lg="6">
            <form-field-toggle
              id="metrics"
              v-model="itemData.config.metrics"
              :label="$t('proxy_rtsp_server.enable_metrics')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="metricsAddress"
              v-model="itemData.config.metricsAddress"
              :label="$t('proxy_rtsp_server.metrics_address')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-toggle
              id="metricsEncryption"
              v-model="itemData.config.metricsEncryption"
              :label="$t('proxy_rtsp_server.enable_metrics_encryption')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="metricsServerKey"
              v-model="itemData.config.metricsServerKey"
              :label="$t('proxy_rtsp_server.metrics_server_key')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="metricsServerCert"
              v-model="itemData.config.metricsServerCert"
              :label="$t('proxy_rtsp_server.metrics_server_cert')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="metricsAllowOrigin"
              v-model="itemData.config.metricsAllowOrigin"
              :label="$t('proxy_rtsp_server.metrics_allow_origin')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-select
              id="metricsTrustedProxies"
              v-model="itemData.config.metricsTrustedProxies"
              :label="$t('proxy_rtsp_server.metrics_trusted_proxies')"
              :options="[]"
              multiple
              taggable
              :push-tags="true"
              :reduce-option="(option) => option"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-toggle
              id="pprof"
              v-model="itemData.config.pprof"
              :label="$t('proxy_rtsp_server.enable_pprof')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="pprofAddress"
              v-model="itemData.config.pprofAddress"
              :label="$t('proxy_rtsp_server.pprof_address')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-toggle
              id="pprofEncryption"
              v-model="itemData.config.pprofEncryption"
              :label="$t('proxy_rtsp_server.enable_pprof_encryption')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="pprofServerKey"
              v-model="itemData.config.pprofServerKey"
              :label="$t('proxy_rtsp_server.pprof_server_key')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="pprofServerCert"
              v-model="itemData.config.pprofServerCert"
              :label="$t('proxy_rtsp_server.pprof_server_cert')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="pprofAllowOrigin"
              v-model="itemData.config.pprofAllowOrigin"
              :label="$t('proxy_rtsp_server.pprof_allow_origin')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-select
              id="pprofTrustedProxies"
              v-model="itemData.config.pprofTrustedProxies"
              :label="$t('proxy_rtsp_server.pprof_trusted_proxies')"
              :options="[]"
              multiple
              taggable
              :push-tags="true"
              :reduce-option="(option) => option"
            />
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import FormFieldText from "@/components/WizardModal/FormFields/FormFieldText.vue";
import FormFieldToggle from "@/components/WizardModal/FormFields/FormFieldToggle.vue";
import FormFieldSelect from "@/components/WizardModal/FormFields/FormFieldSelect.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import useRtpsServerWizard from "./useRtpsServerWizard";

export default {
  name: "MetricsStep",
  components: {
    FormFieldText,
    FormFieldToggle,
    ValidationObserver,
    ValidationProvider,
    FormFieldSelect,
  },
  props: {
    propItemData: {
      type: Object,
      required: true,
    },
  },
  setup(props, context) {
    const configDefaults = {
      metrics: false,
      metricsAddress: "",
      metricsEncryption: false,
      metricsServerKey: "",
      metricsServerCert: "",
      metricsAllowOrigin: "",
      metricsTrustedProxies: [],
      pprof: false,
      pprofAddress: "",
      pprofEncryption: false,
      pprofServerKey: "",
      pprofServerCert: "",
      pprofAllowOrigin: "",
      pprofTrustedProxies: [],
    };

    return useRtpsServerWizard(props, context, configDefaults);
  },
};
</script>
